/**
 * A simple boolean state object
 */
export class DirtyFlag {
  isDirty: boolean;

  constructor() {
    this.isDirty = false;
  }

  /**
   * Update the state of the flag
   * @param state
   */
  update(state?: boolean): boolean {
    if (state == undefined) {
      this.isDirty = !this.isDirty;
    } else {
      this.isDirty = state;
    }

    return this.isDirty;
  }
}

/**
 * Simple reactive state composable for indicating that data needs updated
 * - Creates a reative DirtyFlag object
 *
 * @example const dataState: DirtyFlag = useDirtyFlag();
 */
export const useDirtyFlag = (): DirtyFlag => {
  return reactive(new DirtyFlag());
};
